









import { Component, Vue, Prop } from 'vue-property-decorator'
import { AssetData } from '@/models'
import ApiClient from '@/services/api-client'

@Component
export default class DownloadButton extends Vue {
  private productId = this.$route.params.productId
  private workModuleCode = this.$route.params.workModuleCode
  private spinerVisible = false

  @Prop()
  model!: AssetData

  private download() {
    this.spinerVisible = true
    ApiClient.downloadFileAsset(this.productId, this.workModuleCode, this.model.name)
      .then(() => {
        this.spinerVisible = false
      })
  }
}
